import { MixOperation } from "three";
import { useMemo } from "react";
import { useThree } from "@react-three/fiber";
function useReflectiveMaterial(layers) {
	const environment = useThree((s) => s.scene.environment);
	useMemo(() => {
		for (const [key, { material }] of layers) {
			if (material.type !== "MeshLambertMaterial") continue;
			const mat = material;
			if (key === "transparent") {
				mat.envMap = environment;
				mat.transparent = true;
				mat.reflectivity = .85;
				mat.vertexColors = false;
				mat.opacity = .75;
				mat.combine = MixOperation;
			} else mat.reflectivity = 0;
		}
	}, [layers, environment]);
}
export { useReflectiveMaterial };

//# sourceMappingURL=index242.js.map